import { render } from "./Flash.vue?vue&type=template&id=1dfffae6"
import script from "./Flash.vue?vue&type=script&lang=js"
export * from "./Flash.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__